/**
 * Saneamento do texto do SMS.
 *
 * Um unico caractere fora do alfabeto GSM-7 (acento, "ç", emoji, aspas curvas
 * que o Word insere sozinho) troca a codificacao da mensagem inteira pra UCS-2:
 * o limite cai de 160 pra 70 caracteres e a operadora passa a cobrar 2 ou 3
 * envios pelo mesmo texto.
 *
 * Por isso a troca e' AUTOMATICA e avisada, nao um alerta pedindo pra loja
 * corrigir na mao. Deixar o lojista escolher entre "escrever bonito" e "pagar 3x"
 * e' oferecer uma armadilha.
 */
const MAPA = {
  á:"a",à:"a",â:"a",ã:"a",ä:"a",Á:"A",À:"A",Â:"A",Ã:"A",Ä:"A",
  é:"e",è:"e",ê:"e",ë:"e",É:"E",È:"E",Ê:"E",Ë:"E",
  í:"i",ì:"i",î:"i",ï:"i",Í:"I",Ì:"I",Î:"I",Ï:"I",
  ó:"o",ò:"o",ô:"o",õ:"o",ö:"o",Ó:"O",Ò:"O",Ô:"O",Õ:"O",Ö:"O",
  ú:"u",ù:"u",û:"u",Ú:"U",Ù:"U",Û:"U",
  ç:"c",Ç:"C",ñ:"n",Ñ:"N",ý:"y",Ý:"Y",
  "“":'"', "”":'"', "„":'"', "‘":"'", "’":"'", "‚":"'",
  "–":"-", "—":"-", "…":"...", "•":"-", "º":"o", "ª":"a", "°":"o",
  " ":" ",
};

// Caracteres que o GSM-7 aceita e nao precisam de troca.
// As chaves { } ficam DENTRO do alfabeto permitido: sao os delimitadores dos
// atalhos {nome}/{empresa}, substituidos antes do envio — remove-las aqui
// destruia os proprios atalhos na digitacao (bug pego por print do dono).
const GSM7 = new Set(
  "@$\n\r !\"#%&'()*+,-./0123456789:;<=>?" +
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz" +
  "äöüßé{}"
);

/**
 * Devolve o texto seguro e o que foi trocado ou removido.
 * `trocados` alimenta o aviso na tela — a loja precisa saber o que mudou.
 */
export function sanear(bruto) {
  const original = bruto || "";
  const trocados = new Map();
  let saida = "";

  for (const ch of original) {
    if (MAPA[ch] !== undefined) {
      trocados.set(ch, MAPA[ch]);
      saida += MAPA[ch];
    } else if (GSM7.has(ch)) {
      saida += ch;
    } else {
      // Emoji e simbolos sem equivalente somem: manter um so' deles jogaria a
      // mensagem inteira pra UCS-2 e triplicaria o custo.
      trocados.set(ch, "");
    }
  }

  return {
    texto: saida,
    mudou: saida !== original,
    trocados: [...trocados.entries()].map(([de, para]) => ({ de, para })),
  };
}

export function descreverTrocas(trocados) {
  if (!trocados.length) return "";
  const substituidos = trocados.filter((t) => t.para);
  const removidos = trocados.filter((t) => !t.para);
  const partes = [];
  if (substituidos.length) {
    partes.push(substituidos.slice(0, 6).map((t) => `${t.de} → ${t.para}`).join(", "));
  }
  if (removidos.length) {
    partes.push(`${removidos.slice(0, 4).map((t) => t.de).join(" ")} removido${removidos.length > 1 ? "s" : ""}`);
  }
  return partes.join(" · ");
}
